/**
 * AddTermsCtrl controller
 * Add/edit device
 */

// controller mixins
AddTermsCtrl.mixes = [
  ['m2mCtrlMixin', 'terms', 'subscriptions']
]

/**
 * AddTermsCtrl controller
 *
 * @class AddTermsCtrl
 * @memberof mwApp/packages
 * @see mwApp/terms
 *
 * @ngdoc controller
 * @name mwApp/terms.controller:AddTermsCtrl
 */
/* @ngInject */
export default function AddTermsCtrl ($scope, $uibModalInstance, $http, alertLiteSvc, terms, networkId) {
  var vm = this
  vm.terms = terms
  vm.isNew = !terms.termsAndConditionsId
  vm.showAll = false

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  $http.get(`api/networks/${networkId}/terms-and-conditions/subscriptions`).then(res => {
    vm.subscriptions = res.data.payload
  })

  vm.selectSub = function (form) {
    vm.selectSubscription(vm.subscriptionSelected)
    form.subscriptions.$setDirty()
    form.subscriptions.$setValidity('required', !!vm.terms.subscriptions.length)
  }

  vm.deselectSub = function (subscription, form) {
    vm.deselectSubscription(subscription)
    form.subscriptions.$setDirty()
    form.subscriptions.$setTouched()
    form.subscriptions.$setValidity('required', !!vm.terms.subscriptions.length)
  }

  vm.clear = function (form) {
    while (vm.terms.subscriptions.length) {
      vm.deselectSubscription(vm.terms.subscriptions[vm.terms.subscriptions.length - 1])
    }
    form.subscriptions.$setDirty()
    form.subscriptions.$setTouched()
    form.subscriptions.$setValidity('required', !!vm.terms.subscriptions.length)
  }

  vm.toggleShowAll = function () {
    vm.showAll = !vm.showAll
  }

  /**
   * Save Partner Program
   *
   * @memberof mwApp/terms.controller:AddTermsCtrl
   */
  vm.submit = function (form) {
    form.subscriptions.$setDirty()
    form.subscriptions.$setTouched()
    form.subscriptions.$setValidity('required', !!vm.terms.subscriptions.length)
    vm.setDisable()
    if (form.$invalid) {
      return
    }

    terms._save()
      .then(
        () => {
          $uibModalInstance.close(terms)
          vm.unsetDisable()
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/terms.controller:AddTermssCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
